import { Component, OnInit } from '@angular/core';
import {RealmService} from '../Services/Realm/realm.service';
import {FirebaseService} from '../Services/Firebase/firebase.service';
import {ApiService} from '../Services/Api/api.service';
import {SessionService} from '../Services/Session/session-service.service';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['../../assets/layout/style/layout.css','./contact.component.css']
})
export class ContactComponent implements OnInit {
  contacts: any;
  firebase: FirebaseService;
  types: any[] = [];
  selectedType = true;
  env = environment;
  titleContact: string;
  subTitleContact: string;
  constructor(private realm: RealmService, public fb: FirebaseService, private api: ApiService, private st: SessionService) { }

  ngOnInit() {
    this.env.isContentLoading = true;
    this.types = [];
    this.types.push({ label: 'Local', value: true });
    this.types.push({ label: 'Internacional', value: false });
    this.fb.fetchActivate().then(() => {
      this.getRemoteConfig();
     });
    
    this.firebase = this.fb;
    /*
    this.realm.contactListQuery$.subscribe(value => {
      this.env.isContentLoading = false;
      this.contacts = value;
    });*/
    this.realm.getContact().then((value:any) => {
      this.env.isContentLoading = false;
      this.contacts = value;
      console.log("this.contacts: ", this.contacts);
    })
  }
  getRemoteConfig() {
    this.titleContact = this.fb.getStringRC('txt_title_contact');
    this.subTitleContact = this.fb.getStringRC('txt_subtitle_contact');
  }
  test(event: any) {
    console.log(event);
    //this.selectedType = event.option.value;
  }
}
